import { createAction } from 'redux-actions';

import {
  LOAD_PACKAGE_LIST,
  LOAD_PACKAGE_LIST_SUCCESS,
  LOAD_PACKAGE_LIST_ERROR,
  LOAD_PACKAGE_DETAIL,
  LOAD_PACKAGE_DETAIL_SUCCESS,
  LOAD_PACKAGE_DETAIL_ERROR,
  CREATE_PACKAGE,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_ERROR,
  UPDATE_PACKAGE,
  UPDATE_PACKAGE_SUCCESS,
  UPDATE_PACKAGE_ERROR,
  DELETE_PACKAGE,
  DELETE_PACKAGE_SUCCESS,
  DELETE_PACKAGE_ERROR,
  RESET_PACKAGE,
  LOAD_ASSESSMENT_LIST,
  LOAD_ASSESSMENT_LIST_SUCCESS,
  LOAD_ASSESSMENT_LIST_ERROR,
  RESET_PACKAGE_LIST,
  RESET_PACKAGE_DETAIL,
  RESET_ASSESSMENT_LIST,
} from './type';

//Load list Package
export const loadPackageListAction = createAction(LOAD_PACKAGE_LIST);
export const loadPackageListSuccessAction = createAction(
  LOAD_PACKAGE_LIST_SUCCESS,
);
export const loadPackageListErrorAction = createAction(LOAD_PACKAGE_LIST_ERROR);
export const resetPackageListAction = createAction(RESET_PACKAGE_LIST);

//Load Package detail
export const loadPackageDetailAction = createAction(LOAD_PACKAGE_DETAIL);
export const loadPackageDetailSuccessAction = createAction(
  LOAD_PACKAGE_DETAIL_SUCCESS,
);
export const loadPackageDetailErrorAction = createAction(
  LOAD_PACKAGE_DETAIL_ERROR,
);
export const resetPackageDetailAction = createAction(RESET_PACKAGE_DETAIL);

//Create Package
export const createPackageAction = createAction(CREATE_PACKAGE);
export const createPackageSuccessAction = createAction(CREATE_PACKAGE_SUCCESS);
export const createPackageErrorAction = createAction(CREATE_PACKAGE_ERROR);

//Update Package
export const updatePackageAction = createAction(UPDATE_PACKAGE);
export const updatePackageSuccessAction = createAction(UPDATE_PACKAGE_SUCCESS);
export const updatePackageErrorAction = createAction(UPDATE_PACKAGE_ERROR);

//Delete Package
export const deletePackageAction = createAction(DELETE_PACKAGE);
export const deletePackageSuccessAction = createAction(DELETE_PACKAGE_SUCCESS);
export const deletePackageErrorAction = createAction(DELETE_PACKAGE_ERROR);

//Reset Package
export const resetPackageAction = createAction(RESET_PACKAGE);

//Load assessment list
export const loadAssessmentListAction = createAction(LOAD_ASSESSMENT_LIST);
export const loadAssessmentListSuccessAction = createAction(
  LOAD_ASSESSMENT_LIST_SUCCESS,
);
export const loadAssessmentListErrorAction = createAction(
  LOAD_ASSESSMENT_LIST_ERROR,
);

export const resetAssessmentListAction = createAction(RESET_ASSESSMENT_LIST);
